import React from 'react';
import PropTypes from 'prop-types';

const MartialArtsIcon = ({ className, color = '#006E66' }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="42"
      viewBox="0 0 42 42"
      width="42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.65 3.5L20.3 15.225L18.1825 13.405L24.4825 9.765L16.4675 1.75L14 4.2175L18.795 9.0125L8.75 14.805L6.6675 22.3125L10.9725 29.75L14 28L10.4475 21.84L11.06 19.565L16.625 22.75L17.5 38.5H21L21.875 21L36.75 5.95L34.65 3.5Z"
        fill={color}
      />
      <path
        d="M8.75 12.25C10.683 12.25 12.25 10.683 12.25 8.75C12.25 6.817 10.683 5.25 8.75 5.25C6.817 5.25 5.25 6.817 5.25 8.75C5.25 10.683 6.817 12.25 8.75 12.25Z"
        fill={color}
      />
    </svg>
  );
};

MartialArtsIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default MartialArtsIcon;

